// Referral attribution capture.
//
// A musician shares their public profile (/musician/:username) via link or QR.
// When a visitor signs up from there, we want to record who referred them so a
// reward (e.g. free months per N referred users who convert to paid) can be
// computed later. This module just captures the referrer username through the
// signup round-trip; the backend endpoint stamps `referred_by` on the new user.
//
// The value is stashed in localStorage so it survives the OAuth redirect
// (Google leaves the site and comes back) and a page reload before signup.

const REF_KEY = "fretless_ref";

// Values that are placeholders rather than real referrer usernames.
const IGNORED_REFS = new Set(["profile", "true", "1"]);

export function storeReferral(ref) {
  const r = (ref || "").trim();
  if (!r || IGNORED_REFS.has(r.toLowerCase())) return;
  try {
    localStorage.setItem(REF_KEY, r);
  } catch {
    /* private mode / storage disabled — attribution is best-effort */
  }
}

export function getStoredReferral() {
  try {
    return localStorage.getItem(REF_KEY) || "";
  } catch {
    return "";
  }
}

export function clearStoredReferral() {
  try {
    localStorage.removeItem(REF_KEY);
  } catch {
    /* no-op */
  }
}

// Attach the stored referral to the just-created account. Best-effort and
// non-fatal: never let a referral hiccup break the signup flow. `apiClient` is
// passed in (rather than imported) to avoid a circular import with App.js.
export async function attachStoredReferral(apiClient) {
  const ref = getStoredReferral();
  if (!ref) return;
  try {
    await apiClient.post("/auth/attach-referral", { ref });
  } catch {
    /* backend not ready / already attributed / referrer not found — ignore */
  }
  clearStoredReferral();
}
